import { Dropdown, Space } from "antd";
import type { MenuProps } from "antd";
import { DownOutlined } from "@ant-design/icons";

import { __currentUser__ } from "../../graphql/policies";
import { MarketType } from "../../types/types";

// i18n
import { useTranslation } from "react-i18next";

const getItems = (markets: MarketType[]) => {
  return markets.map((market) => ({
    key: market,
    label: <p className="px-2 py-1">{market}</p>,
  }));
};

export default function MarketDropdown({
  selectedMarket,
  setSelectedMarket,
  disabled = false,
  alwaysShow = false,
  includeJp = false,
}: {
  selectedMarket: MarketType;
  setSelectedMarket: (value: React.SetStateAction<MarketType>) => void;
  disabled?: boolean;
  alwaysShow?: boolean;
  includeJp?: boolean;
}) {
  const allMarkets: MarketType[] = includeJp
    ? ["HK", "KR", "TW", "JP"]
    : ["HK", "KR", "TW"];

  const { afUserMarkets } = __currentUser__() || {};
  let items: MenuProps["items"] = alwaysShow
    ? getItems(allMarkets)
    : afUserMarkets
    ? getItems(afUserMarkets.map((item) => item?.market as MarketType))
    : undefined;
  const { t: trans } = useTranslation(["clubApp", "common"]);

  const handleDropdownItemClick = (e: any) => {
    const market = e.key as MarketType;

    setSelectedMarket(market);
  };

  return alwaysShow || (items && items.length > 1) ? (
    <Dropdown
      menu={{ onClick: handleDropdownItemClick, items }}
      className={disabled ? "cursor-not-allowed" : "cursor-pointer"}
      disabled={disabled}
    >
      <Space>
        {trans("common:common.market") + " : " + selectedMarket }
        <DownOutlined />
      </Space>
    </Dropdown>
  ) : null;
}
